import React from 'react';
import appleTv from '../img/appletv.png';
import IconBadge from './IconBadge';

const Badge: React.FC<React.PropsWithChildren<unknown>> = props => (
  <IconBadge url={appleTv.src} {...props} />
);

export default Badge;
